import { render, staticRenderFns } from "./DisplayWaitAction.vue?vue&type=template&id=1601e690&"
import script from "./DisplayWaitAction.vue?vue&type=script&lang=js&"
export * from "./DisplayWaitAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports